import { useState } from 'react';
import { useSelector } from 'react-redux';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormDateTimeField from 'modules/ui/editform/fields/EditFormDateTimeField';
import EventEditService from '../service/EventEditService';

const config = data => {
	return {
		key: 'eventEditForm',
		text: 'Event',
		textKey: 'event',
		service: EventEditService,
		editableAccess: data.formData.editableAccess,
		editableFields: data.formData.editableFields,
		hideSaveButton: true,
		watchTitleKey: 'text',
		fields: [
			{
				key: 'project',
				text: 'Project',
				textKey: 'Project',
				component: EditFormSelectField,
				items: data.formData.entityMap.project,
				visibleIf: () => data.user.isSuperAdmin,
				required: true
			},
			{
				key: 'timestamp',
				text: 'Timestamp',
				textKey: 'timestamp',
				component: EditFormDateTimeField
			},
			{
				key: 'device',
				text: 'Device',
				textKey: 'device',
				component: EditFormSelectField,
				items: data.formData.entityMap.device
			},
			{
				key: 'severity',
				text: 'Severity',
				textKey: 'severity',
				component: EditFormSelectField,
				type: 'enum',
				items: data.formData.enumMap.severity
			},
			{
				key: 'text',
				text: 'Text',
				textKey: 'text',
				component: EditFormTextField,
				multiline: true
			},
			{
				key: 'code',
				text: 'Code',
				textKey: 'code',
				component: EditFormTextField,
				type: 'number'
			}
		]
	};
};

function EventEditForm() {
	const user = useSelector(({ auth }) => auth.user);
	const [formData, setFormData] = useState(null);
	if (formData == null) {
		EventEditService.getFormData().then(result => setFormData(result));
		return <></>;
	}
	const myConfig = config({ formData, user });
	return <EditFormPage config={myConfig} />;
}

export default EventEditForm;
